module.exports = __webpack_public_path__ + "img/huesges_logo.198de064.png";